import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-strelci',
  templateUrl: './strelci.component.html',
  styleUrls: ['./strelci.component.scss']
})
export class StrelciComponent implements OnInit {
  strelci: any[] = [];
  loading = false;
  error: string | null = null;
  showFilter = false;
  showAddDialog = false;
  showEditDialog = false;
  editStrelec: any = null;
  currentFilters: any = {}; // <-- Store current filters

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.loadStrelci();
  }

  loadStrelci(filters?: any): void {
    const apiUrl = 'https://testapi.ovh/api/strelstvo/strelec';

    this.loading = true;
    this.error = null;

    // Use currentFilters if filters not provided
    const params = filters !== undefined ? filters : this.currentFilters;

    this.http.get<any[]>(apiUrl, { params }).subscribe(
      (strelciData) => {
        this.strelci = strelciData;
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching strelci:', error);
        this.strelci = [];
        this.loading = false;
        this.error = 'Napaka pri nalaganju strelcev!';
      }
    );
  }

  onFilter(filters: any) {
    this.showFilter = false;
    // Remove empty filters
    Object.keys(filters).forEach(key => {
      if (filters[key] === '' || filters[key] === null) {
        delete filters[key];
      }
    });
    this.currentFilters = { ...filters }; // Save filters
    this.loadStrelci(this.currentFilters);
  }

  onAdd(strelec: any) {
    this.showAddDialog = false;
    this.loadStrelci(this.currentFilters); // Use current filters
  }

  onEdit(strelec: any) {
    this.editStrelec = {
      ...strelec,
      klub: String(strelec.club_id || strelec.klub),
      spol: strelec.gender || strelec.spol
    };
    this.showEditDialog = true;
  }

  onEditSave(updated: any) {
    this.showEditDialog = false;
    this.loadStrelci(this.currentFilters); // Use current filters
  }
}
